import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from './auth.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HelpersService {
  private viewport = new BehaviorSubject<any>({});
  viewport$ = this.viewport.asObservable();
  private formGroup = new BehaviorSubject<any>({});
  private nextClick = new BehaviorSubject<any>({});
  private backUrl = new BehaviorSubject<any>({});
  constructor(private authService: AuthService) { }
  updateNext(data: any) {
    this.nextClick.next(data);
  }
  updateBackUrl(data: any) {
    this.backUrl.next(data);
  }
  updateformGroup(data: any) {
    this.formGroup.next(data);
  }
  getNext(): Observable<any> {
    return this.nextClick.asObservable();
  }
  getBackUrl(): Observable<any> {
    return this.backUrl.asObservable();
  }
  getFormGroup(): Observable<any> {
    return this.formGroup.asObservable();
  }
  role() {
    let userData = this.authService.getUserData();
    if (userData !== null) {
      let parseData = JSON.parse(userData);
      if (!parseData?.userRoles?.length) {
        return '';
      }
      let user_role = parseData?.userRoles[0]?.name ?? null;
      return user_role;
    } else {
      return null;
    }
  }
  role_id() {
    let userData = this.authService.getUserData();
    if (userData !== null) {
      let parseData = JSON.parse(userData);
      if (!parseData?.userRoles?.length) {
        return '';
      }
      let roleId = parseData?.userRoles[0]?.id ?? null;
      return roleId;
    } else {
      return null;
    }
  }
  CompanyAccountId() {
    let userData = this.authService.getUserData();
    if (userData !== null) {
      let parseData = JSON.parse(userData);

      let CompanyAccountId = parseData?.companyAccountId ?? null;
      return CompanyAccountId;
    } else {
      return null;
    }
  }
  userId() {
    let userData = this.authService.getUserData();
    if (userData !== null) {
      let parseData = JSON.parse(userData);

      let userId = parseData?.userId ?? null;
      return userId;
    } else {
      return null;
    }
  }
  userEmail() {
    let userData = this.authService.getUserData();
    if (userData !== null) {
      let parseData = JSON.parse(userData);
      let email = parseData?.email ?? null;
      return email;
    } else {
      return null;
    }
  }
  approvalLevel() {
    let userData = this.authService.getUserData();
    if (userData !== null) {
      let parseData = JSON.parse(userData);
      let approvalLevel = parseData?.approvalLevel ?? null;
      return approvalLevel;
    } else {
      return null;
    }
  }
  userDetails() {
    let userData = this.authService.getUserData();
    if (userData !== null) {
      let parseData = JSON.parse(userData);
      return parseData;
    } else {
      return null;
    }
  }
  ssoRedirectUrl() {
    let userData = this.authService.getUserData();
    if (userData !== null) {
      let parseData = JSON.parse(userData);
      return parseData?.ssoRedirectUrl;
    } else {
      return null;
    }
  }
  redirectToSsoLogin() {
    const targetUrl = this.ssoRedirectUrl();
    window.location.replace(targetUrl || environment.REDIRECT_URL);
  }
  isDirector() {
    let userData = this.authService.getUserData();
    if (userData !== null) {
      let parseData = JSON.parse(userData);
      return parseData?.isDirector;
    } else {
      return false;
    }
  }

  accountTeam(): "AC1" | "AC2" | "AC3" {
    let userData = this.authService.getUserData();
    if (userData !== null) {
      let parseData = JSON.parse(userData);      
      return parseData?.accountTeam ?? "";
    } else {
      return "AC1";
    }
  }
  updateViewPort(data: any) {
    this.viewport.next(data);
  }
  formatDateToISO(date: any): string {
    if (!date) return '';

    const d = new Date(date);

    // This is the key: Use getFullYear, getMonth, getDate → avoids timezone shift
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
}
